import { sample } from 'effector';
import { $requestsList } from './stores.js';
import { editRequestFx, getRequestsListFx } from './effects.js';
import { changeCommentEv, changeStatusEv } from './events.js';

$requestsList.on(getRequestsListFx.doneData, (state, payload) => {
  return payload.map((item, index) => {
    return {
      ...item,
      key: `request-table-item-${index}`,
    };
  });
});

sample({
  clock: changeStatusEv,
  fn: (clock) => {
    return {
      id: clock.id,
      data: {
        status: clock.value,
      },
    };
  },
  target: editRequestFx,
});

sample({
  clock: changeCommentEv,
  fn: (clock) => {
    return {
      id: clock.id,
      data: {
        comment: clock.value,
      },
    };
  },
  target: editRequestFx,
});

sample({
  source: $requestsList,
  clock: editRequestFx.doneData,
  fn: (source, clock) => {
    const requestIndex = source.findIndex((item) => item.id === clock.id);
    return [
      ...source.slice(0, requestIndex),
      clock,
      ...source.slice(requestIndex + 1),
    ];
  },
  target: $requestsList,
});
